import { Feil } from '../diverse/Feil';
import { Sesjonsklient } from './Sesjonsklient';

export class Loggklient {
	constructor(sid, installasjon) {
		this._sesjonsklient = new Sesjonsklient(sid);
		this._installasjon = installasjon;
	}
	error(last) {
		this._logg('error', last);
	}
	info(last) {
		this._logg('info', last);
	}
	warn(last) {
		this._logg('warn', last);
	}
	_logg(niva, last) {
		if (!(last instanceof Feil)) {
			last = new Feil('Ubehandla unntak').med('unntak', last);
		}
		const utvidaLast = last
			.med('navigator.userAgent', navigator.userAgent)
			.med('url', window.location.href);
		return this._sesjonsklient.fetch(
			this._installasjon.getBase() + 'logging/' + niva,
			{
				body: JSON.stringify(utvidaLast),
				headers: {
					'Content-type': 'application/json',
				},
				method: 'POST',
			}
		);
	}
}
